export default __webpack_public_path__ + "static/media/control_room.220e4f20.gif";